import React, { useEffect, useState } from "react";
import axios from "axios";
import { Download, RefreshCw, Users, ArrowLeft, Loader2 } from "lucide-react";
import { BRAND } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/leads`);
      setLeads(res.data || []);
    } catch (e) {
      setLeads([]);
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const fmt = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    return dt.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  };

  return (
    <div className="min-h-screen bg-[#050912] text-slate-200">
      <header className="border-b border-[rgba(46,155,255,0.14)] bg-[#060b16]/90 backdrop-blur-xl sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-5 h-[70px] flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <img src={BRAND.logo} alt="logo" className="h-9 w-9 rounded-lg object-cover ring-1 ring-[rgba(46,155,255,0.4)]" />
            <span className="font-extrabold tracking-tight">THE REAL <span className="text-blue-grad">ALGO</span> · Leads</span>
          </div>
          <a href="/" className="btn-ghost inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </a>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 py-10">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div>
            <h1 className="font-display text-3xl font-bold text-white flex items-center gap-3">
              <Users className="w-7 h-7 text-[#2e9bff]" /> Consultation Leads
            </h1>
            <p className="text-slate-400 text-sm mt-1">{leads.length} total submission{leads.length !== 1 ? "s" : ""}</p>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={load} className="btn-ghost inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold">
              <RefreshCw className="w-4 h-4" /> Refresh
            </button>
            <a href={`${API}/leads/export`} className="btn-primary inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold">
              <Download className="w-4 h-4" /> Download Excel
            </a>
          </div>
        </div>

        <div className="glass-card rounded-2xl overflow-hidden">
          {loading ? (
            <div className="py-20 flex items-center justify-center text-slate-400 gap-2">
              <Loader2 className="w-5 h-5 animate-spin" /> Loading leads...
            </div>
          ) : leads.length === 0 ? (
            <div className="py-20 text-center text-slate-400">No leads yet. Submissions from the contact form will appear here.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-slate-400 border-b border-white/10">
                    <th className="px-4 py-3 font-medium">Date</th>
                    <th className="px-4 py-3 font-medium">Name</th>
                    <th className="px-4 py-3 font-medium">WhatsApp</th>
                    <th className="px-4 py-3 font-medium">Email</th>
                    <th className="px-4 py-3 font-medium">Interested In</th>
                    <th className="px-4 py-3 font-medium">Message</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((l) => (
                    <tr key={l.id} className="border-b border-white/5 hover:bg-[rgba(46,155,255,0.05)] transition-colors">
                      <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{fmt(l.created_at)}</td>
                      <td className="px-4 py-3 text-white font-medium whitespace-nowrap">{l.name}</td>
                      <td className="px-4 py-3 text-[#22e39a] whitespace-nowrap">{l.whatsapp}</td>
                      <td className="px-4 py-3 text-slate-300">{l.email || "—"}</td>
                      <td className="px-4 py-3">
                        <span className="text-[11px] px-2.5 py-1 rounded-full bg-[rgba(46,155,255,0.12)] border border-[rgba(46,155,255,0.25)] text-[#9fd0ff] whitespace-nowrap">{l.interest}</span>
                      </td>
                      <td className="px-4 py-3 text-slate-400 max-w-xs">{l.message || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
